import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HidePaymentErrorMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type HidePaymentErrorMutationPage = { readonly __typename?: 'RootMutationType', readonly disableFlag: boolean };


export const HidePaymentErrorDocument = gql`
    mutation HidePaymentError {
  disableFlag(name: PAYMENT_ERROR)
}
    `;
export type HidePaymentErrorMutationFn = Apollo.MutationFunction<HidePaymentErrorMutationPage, HidePaymentErrorMutationVariables>;

/**
 * __useHidePaymentErrorMutation__
 *
 * To run a mutation, you first call `useHidePaymentErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHidePaymentErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hidePaymentErrorMutation, { data, loading, error }] = useHidePaymentErrorMutation({
 *   variables: {
 *   },
 * });
 */
export function useHidePaymentErrorMutation(baseOptions?: Apollo.MutationHookOptions<HidePaymentErrorMutationPage, HidePaymentErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HidePaymentErrorMutationPage, HidePaymentErrorMutationVariables>(HidePaymentErrorDocument, options);
      }
export type HidePaymentErrorMutationHookResult = ReturnType<typeof useHidePaymentErrorMutation>;
export type HidePaymentErrorMutationResult = Apollo.MutationResult<HidePaymentErrorMutationPage>;
export type HidePaymentErrorMutationOptions = Apollo.BaseMutationOptions<HidePaymentErrorMutationPage, HidePaymentErrorMutationVariables>;